<template>
  <div class="c block" >
    <div class="title">
      <slot name="title"></slot>
    </div>
    <slot name="body"></slot>
  </div>
</template>

<script>
  export default {
    name: "card",
  };
</script>

<style scoped>

  .c {
    @apply w-full pt-6.5 pb-9 px-5 text-grey-text text-left bg-white;
  }

  .title {
    @apply text-2xl mb-9 text-black;
  }

  @screen lg {
    .title {
      @apply text-2xl my-4 text-black;
    }
  }

</style>

